function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m2.57.5c-1.15 0-2.07.93-2.07 2.07v8.53c0 .97.79 1.75 1.76 1.75h10.49c.47 0 .91-.18 1.24-.51s.51-.77.51-1.24v-8.52c0-1.15-.93-2.07-2.07-2.07h-9.86zm10.17 9.47c0 .67-.54 1.21-1.21 1.21h-8.07c-.67 0-1.21-.54-1.21-1.21v-4.26c0-.67.54-1.21 1.21-1.21h8.07c.67 0 1.21.54 1.21 1.21z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15 13.36"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/laptop-outlined.60431a3a.svg";
export { SvgComponent as ReactComponent };